import React, { Component } from 'react';
import '../../App.css';
import '../../styles/app-demo.css';
import loginHeader from '../../assets/mobile-app/mobile-app-login-header.png';

class Login extends Component {

  constructor(props){
    super(props)
    this.state = {
      userName: 'User'
    }
    this.handleName = this.handleName.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.toggleNewRoute = this.toggleNewRoute.bind(this);
  }

  handleName(e) {
    this.setState({
      userName: e.target.value
    })
  }

  handleLogin() {
    this.props.loginCallback(this.state.userName)
  }

  toggleNewRoute() {
    this.props.toggleNewRoute('atm locator')
  }

  render() {

    return (
      <section id="mobile-app-login-screen">
        <img id="login-header" src={loginHeader} alt={''} />
        <div id="login-wrapper">
          <p>Welcome! Please login</p>
          <input onChange={this.handleName} placeholder={"Name"} />
          <button onClick={this.handleLogin}>LOG IN</button>
          <div id="find-atm-login-container">
            <p onClick={this.toggleNewRoute}>FIND ATMS</p>
          </div>
         </div>
      </section>
    );
  }
}

export default Login;
